export default {
  'LANGUAGE' (state) {
    return state.language
  },
  'LANGUAGES' (state) {
    return state.languages
  }
}
